import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CommercialSessionTable from './CommercialSessionTable';
import PersonalSessionTable from './PersonalSessionTable';

/**
 * Charging Sessions Container Component
 * @returns {any} The result
 */
function PartnerChargingSessions() {
  const { i18n } = useTranslation();
  const [currentPage, setCurrentPage] = useState<string>('commercial');

  return (
    <div className="body-container" dir={i18n.dir()}>
      <div className="table-content">
        {currentPage === 'commercial' && (
          <CommercialSessionTable setCurrentPage={setCurrentPage} currentPage={currentPage} />
        )}
        {currentPage === 'personal' && (
          <PersonalSessionTable setCurrentPage={setCurrentPage} currentPage={currentPage} />
        )}
      </div>
    </div>
  );
}

export default PartnerChargingSessions;
